import Article from '../src/Article/index.tsx';
export default Article;
